import { MediumText } from "../../../../../components/typography";

export default function TypeItemPaymentTab() {
    return (
        <MediumText>Спосіб оплати елемент</MediumText>
    )
}